import "./Header.css";
import { useTranslation } from "react-i18next";
import { useAudio } from "../AudioProvider.jsx";
import { useMoneda } from "../../context/MonedaContext.js";
// Iconos en uso
import {
  BsVolumeUpFill,
  BsFillVolumeMuteFill,
  BsGearFill,
} from "react-icons/bs";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// Definimos afuera para que no se cree en cada render
const idiomas = [
  { label: "Español", code: "es" },
  { label: "English", code: "en" },
  { label: "Português", code: "pt" },
];

const opMenu = [
  { label: "Terapias holísticas", code: "/terapiasHolisticas" },
  { label: "Masajes ayurvédicos", code: "/masajesAyurvedicos" },
  { label: "Coaching ontológico", code: "/vistaDetallada/13" },
  { label: "Sobre mí", code: "/sobreMi" },
  { label: "Preguntas frecuentes", code: "/faq" },
  { label: "Contacto", code: "/sobreMi" },
];

const monedas = ["ARS", "USD","MXN","CLP","BRL","EUR"];

const HeaderMoviles = () => {
  const { i18n } = useTranslation();

  const [idioma, setIdioma] = useState("Español"); // Para el select
  const [mostrarMenu, setMostrarMenu] = useState(false);

  useEffect(() => {
    const savedLang = localStorage.getItem("i18nextLng");
    const idiomaEncontrado = idiomas.find((i) => i.code === savedLang);
    if (savedLang && idiomaEncontrado) {
      i18n.changeLanguage(savedLang);
      setIdioma(idiomaEncontrado.label); // Mostrar "Español", "English", etc.
    }
  }, [i18n]); // <-- Solo i18n, porque idiomas ya no cambia

  const seleccionarIdioma = (nuevoIdioma) => {
    const idiomaSeleccionado = idiomas.find((i) => i.label === nuevoIdioma);
    if (idiomaSeleccionado) {
      i18n.changeLanguage(idiomaSeleccionado.code);
      localStorage.setItem("i18nextLng", idiomaSeleccionado.code); // Guardado en local storage
      setIdioma(idiomaSeleccionado.label);
      setMostrarMenu(false);
    }
  };

  const {moneda, setMoneda} = useMoneda(); // Para el select
  const [mostrarMenu2, setMostrarMenu2] = useState(false);

  const seleccionarMoneda = (nuevaMoneda) => {
    setMoneda(nuevaMoneda);
    setMostrarMenu2(false);
  };

  const [mostrarMenuMoviles, setMostrarMenuMoviles] = useState(false);
  const [mostrarMenuConfig, setMostrarMenuConfig] = useState(false);

  const toggleMenu = () => {
    setMostrarMenu(!mostrarMenu);
    setMostrarMenu2(false);
  };

  const toggleMenu2 = () => {
    setMostrarMenu(false);
    setMostrarMenu2(!mostrarMenu2);
  };

  // Control de audio
  const { activo, setActivo } = useAudio();

  return (
    <section className="headerDownMovilesMS">
      <div className="menuMovilesMS">
        <div
          className="menuBotonMS"
          onClick={() => setMostrarMenuMoviles(!mostrarMenuMoviles)}
        >
          <span className="textoMenuMS">Menú</span>
          {mostrarMenuMoviles ? (
            <IoIosArrowUp size="12px" />
          ) : (
            <IoIosArrowDown size="12px" />
          )}
        </div>
        <ul className={`listaMenuMS ${mostrarMenuMoviles ? "visible" : ""}`}>
          {opMenu.map(({ label, code }) => (
            <Link to={`${code}`}>
              <li
                key={label}
                onClick={() => setMostrarMenuMoviles(!mostrarMenuMoviles)}
                className="opcionMenuMS"
              >
                {label}
              </li>
            </Link>
          ))}
        </ul>
      </div>

      <div className="VolumenMS">
        <span>
          {activo ? (
            <BsVolumeUpFill color="#3f3b88" size="22px" />
          ) : (
            <BsFillVolumeMuteFill color="#3f3b88" size="22px" />
          )}
        </span>
        <label className="InterruptorMS">
          <input
            type="checkbox"
            checked={activo}
            onChange={() => setActivo((a) => !a)}
          />
          <span className="SliderMS" />
        </label>
      </div>

      <div className="menuMovilesMS">
        <div
          className="menuBotonMS"
          onClick={() => setMostrarMenuConfig(!mostrarMenuConfig)}
        >
          <BsGearFill color="#3f3b88" size="22px" />
        </div>
        <div className={`menuConfigMS ${mostrarMenuConfig ? "visible" : ""}`}>
          <div className="idiomaMS">
            <div className="idiomaBotonMS" onClick={toggleMenu}>
              <span className="idiomaTextoMS">{idioma}</span>
              {mostrarMenu ? (
                <IoIosArrowUp size="12px" />
              ) : (
                <IoIosArrowDown size="12px" />
              )}
            </div>
            <ul className={`idiomaListaMS ${mostrarMenu ? "visible" : ""}`}>
              {idiomas.map(({ label }) => (
                <li
                  key={label}
                  onClick={() => seleccionarIdioma(label)}
                  className="idiomaOpcionMS"
                >
                  {label}
                </li>
              ))}
            </ul>
          </div>

          <div className="monedaMS">
            <div className="monedaBotonMS" onClick={toggleMenu2}>
              <span className="monedaTextoMS">{moneda}</span>
              {mostrarMenu2 ? (
                <IoIosArrowUp size="12px" />
              ) : (
                <IoIosArrowDown size="12px" />
              )}
            </div>
            <ul className={`monedaListaMS ${mostrarMenu2 ? "visible" : ""}`}>
              {monedas.map((monedaItem) => (
                <li
                  key={monedaItem}
                  onClick={() => seleccionarMoneda(monedaItem)}
                  className="monedaOpcionMS"
                >
                  {monedaItem}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeaderMoviles;
